import { FieldPolicy } from '@apollo/client';
import { offsetLimitPagination } from '@apollo/client/utilities';
import 'isomorphic-fetch';
import { getKeys } from '.';

export const memoryFields = {
  getSlots: {
    fields: ['slots'],
    keyArgs: ['GetSlotsInput'],
    offsetKey: 'slots_start'
  }
};

export const combineFields = (data: Record<string, any>) => {
  const queryName = Object.keys(data)[0] as keyof typeof memoryFields;
  const fieldsToCombine = memoryFields[queryName]?.fields;
  let fieldsCombined = [] as Record<string, any>[];
  if (fieldsToCombine?.length) {
    const newFields = fieldsToCombine.reduce((acc, field) => {
      return [...acc, ...((data?.[queryName] as Record<string, Record<string, any>[]>)?.[field] || [])];
    }, fieldsCombined);
    fieldsCombined = newFields;
  } else {
    fieldsCombined = data?.[queryName] as Record<string, any>[];
  }
  return fieldsCombined;
};

type KeyArgs = Parameters<typeof offsetLimitPagination>[0];
type MemoryField = { fields?: string[]; keyArgs?: KeyArgs; offsetKey?: string };

export const customOffsetLimitPagination = (memoryField: MemoryField) => {
  const keyArgs = memoryField?.keyArgs;
  return {
    ...offsetLimitPagination(keyArgs),
    merge: (...mergeArgs: Parameters<FieldPolicy['merge']>) => {
      const [existing, incoming, { args }] = mergeArgs;
      const offset = args?.[memoryField.offsetKey || 'offset'] || 0;
      const hasFields = !!memoryField?.fields && !!memoryField.fields.length;

      if (!offset) {
        return incoming;
      }

      if (!hasFields) {
        return offsetLimitPagination(keyArgs)?.merge?.(...mergeArgs);
      }

      const existingKeys = getKeys(existing || {});

      const nonFieldsKeys = existingKeys?.filter(key => !memoryField.fields?.includes(key));

      const nonFields = nonFieldsKeys.reduce((acc, key) => {
        return {
          ...acc,
          [key]: existing[key]
        };
      }, {});

      const merged = memoryField?.fields?.reduce((acc, key) => {
        const merged = offsetLimitPagination(keyArgs)?.merge?.(existing?.[key], incoming?.[key], { args });
        return { ...acc, ...nonFields, [key]: merged };
      }, {});
      return merged;
    }
  };
};
